import camelCase from 'lodash/camelCase';
import { Gruser } from '../types/papi';
import { PapiModuleData } from '@wix/da-papi-types';

export const generateGruserObjectId = ({ gruserId, gruserTypeid, gruserItemid }: Gruser) => {
  return `${gruserId}-${gruserTypeid}-${gruserItemid || 'null'}`;
};

export const getModuleDataFromPapiModule = (module: PapiModuleData) => {
  const { moduleData } = module;
  const { dataKey = '' } = moduleData;
  return moduleData[camelCase(dataKey)] || {};
};

export const isModuleResponse = response =>
  response &&
  response.hasOwnProperty('id') &&
  response.hasOwnProperty('version') &&
  response.hasOwnProperty('moduleData');
